import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
/**
 * Function: FloatingButtonOpen
 *
 * Description:
 * Renders the open view of the floating action button. It displays a CloseRoundedIcon with specified styles and transition properties based on the isOpen state.
 *
 * @param {boolean} isOpen - A boolean indicating whether the floating action button is open or closed.
 *
 * @returns {JSX.Element} A JSX element representing the open view of the floating action button.
 */
const FloatingButtonOpen = ({ isOpen = false }) => {
  return (
    <CloseRoundedIcon
      style={{
        transitionTimingFunction: 'cubic-bezier(0.4, 0, 0.2, 1) !important',
      }}
      className={`ui-flex ui-items-center ui-z-[1150] ui-m-3 ui-justify-center !ui-w-[18px] !ui-h-[18px] ui-transition-opacity ui-duration-300 ui-opacity-0 ${isOpen ? 'ui-opacity-100' : ''}`}
    />
  );
};

export default FloatingButtonOpen;
